import Modal from 'react-bootstrap/Modal';
import { useEffect, useState } from 'react';
import PrimaryButton from '../../components/button';
import TextField from '../../components/textFiled';
import Selectfield from '../../components/selectfield';
import ViewCategoriesModal from './ViewCategoriesModal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useCreateCategoryMutation } from '../../api';

type Props = {
  show: boolean;
  hide: () => void;
};

export default function CreateCategoryModal({ show, hide }: Props) {
  const [name, setName] = useState('');
  const [type, setType] = useState('Other');
  const [error, setError] = useState('');
  const [viewList, setViewList] = useState(false);

  useEffect(() => {
    if (show) {
      setName('');
      setType('Other');
      setError('');
    }
  }, [show]);

  const [createCategory, { isLoading }] = useCreateCategoryMutation();

  const SNACK_KEYWORDS = ['biscuits', 'crisps', 'cookies', 'chips', 'nuts', 'chocolate', 'sweets', 'snacks', 'potato', 'fries', 'cake', 'mandazi', 'samosa'];
  const DRINK_KEYWORDS = ['juice', 'water', 'soda', 'tea', 'milk', 'coffee', 'smoothies', 'drinks', 'beverages', 'fanta', 'coke', 'beer', 'wine', 'sprite', 'cocktail'];

  const handleNameChange = (val: string) => {
    setName(val);
    const lower = val.toLowerCase();
    if (SNACK_KEYWORDS.some(k => lower.includes(k))) {
      setType('Snacks');
    } else if (DRINK_KEYWORDS.some(k => lower.includes(k))) {
      setType('Drinks');
    }
  };

  const handleAdd = async () => {
    const val = name.trim();
    if (!val) {
      setError('Sub Category name is required');
      return;
    }
    try {
      await createCategory({ name: val, type }).unwrap();
      toast.success('Sub Category created');
      setName('');
      setTimeout(() => hide(), 900);
    } catch (e: any) {
      const msg = e?.data?.message || 'Failed to create sub category';
      setError(msg);
      toast.error(msg);
    }
  };

  const typeItems = [
    { label: 'Snacks', value: 'Snacks' },
    { label: 'Drinks', value: 'Drinks' },
    { label: 'Other', value: 'Other' },
  ];

  return (
    <Modal show={show} onHide={hide} centered>
      <Modal.Body>
        <div className='customer-details-title-ctn'>
          <span className='customer-details-title'>Create Sub Category</span>
        </div>
        <div className='modal-details-content'>
          <Selectfield
            label="Main Category"
            value={type}
            menuItems={typeItems}
            handleChange={(e: any) => setType(e.target.value)}
            required
          />

          <TextField
            label='Sub Category Name'
            value={name}
            onChange={(e: any) => { handleNameChange(e.target.value); setError(''); }}
            required
            type='text'
            placeholder='e.g., Biscuits'
            error={!!error}
            helperText={error}
          />

          <div className='w-full flex justify-end gap-3'>
            <PrimaryButton label={isLoading ? 'Adding...' : 'Add'} onClick={handleAdd} disabled={isLoading} fullWidth={false} />
          </div>
          <div className='w-full flex justify-end mt-2'>
            <PrimaryButton label='View Categories' fullWidth={false} size='small' onClick={() => setViewList(true)} />
          </div>
        </div>
      </Modal.Body>
      <ToastContainer position="top-right" autoClose={2500} hideProgressBar theme="light" />

      {viewList && (
        <ViewCategoriesModal
          show={viewList}
          hide={() => setViewList(false)}
        />
      )}
    </Modal>
  );
}
